/*global VeloxWebView, moment, VeloxDatabaseClient*/

/**
 * This interceptors deals with user session management
 *  - ajax interceptor do redirect to login on 401 responses
 *  - navigation interceptor to redirect to login if no session opened
 *  - startup interceptor to refresh user session on application startup
 */

function isActivationScreen(app){
    var currentRoutes = app._getRoutes(app._currentPosition()) ;
    if(currentRoutes.length === 3 && (currentRoutes[2].route === "activate" 
        || currentRoutes[2].route === "renewpass"
        || currentRoutes[2].route === "optin"
        || currentRoutes[2].route === "download")
        ){
        //on activate screen, don't try to refresh user
        return true ;
    }
    return false ;
}

module.exports = [
    {   
        type: "ajax", //called on ajax responses
        interceptor: function (app, err, request, response, next) {
            if(isActivationScreen(app)){
                return next();
            }
            var userCorrectlyConnected = true;
            if(request.url === "syncGetTime" && response.status === 200){
                //we prepare to sync, we must check if we are really logged
                var savedCurrentUser = localStorage.getItem("velox_current_user") ;
                userCorrectlyConnected = false;
                if(savedCurrentUser){
                    savedCurrentUser = JSON.parse(savedCurrentUser) ;
                    if(savedCurrentUser.login === app.context.api.currentUser.login){
                        userCorrectlyConnected = true ;
                    }
                }
            }else if(app.context.api && app.context.api.api.isOffline()){
                var lastUser = localStorage.getItem("last_user") ;
                if(lastUser){
                    app.context.api.currentUser = JSON.parse(lastUser);
                    return next();
                }
            }
            if (
                !userCorrectlyConnected //case when user is not connected (was in offline mode)
                ||
                (   //case not connected because was refused by server
                    response &&
                    (
                    (response.status === 401 && response.url !== "auth/user") || //no session error
                    (response.url === "refreshUser?" && response.response.login === "anonymous") //or anonymous user
                    )
                ) 
            ) {
                //user should login

                if(!userCorrectlyConnected){
                    response.status = 401 ;
                    response.response = "NOT_LOGGED" ;
                    next(response) ;
                }

                //close all waiter that will never close because we drop the response
                VeloxWebView.closeAllWaiters();

                if (app.isSuspended() === "login") {
                    //already suspended, don't do anything
                    return;
                }


                //suspend to login
                app.suspendNavigation("login", app.context.controllers.loginController);


                if (app.currentPosition) {
                    //display message to user
                    VeloxWebView.error(VeloxWebView.tr("login.disconnectLoginAgain"), function () {
                        app.context.controllers.loginController.focusLogin();
                    });
                }
                if(response.url === "refreshUser?"){
                    next() ;
                }
                
                return;
            }
            next();
        }
    },
    {
        type: "navigation", //called on navigation
        interceptor: function (app, context, next){
            if(app.context.api.currentUser && app.context.api.currentUser.login !== "anonymous"){ 
                //OK logged
                app.context.api.currentReseller = "";
                app.context.api.licenseErr = false ;
                if(app.context.api.currentUser.realms.length > 0){
                    app.context.api.currentReseller = app.context.api.currentUser.realms[0].realm.code ;
                    app.context.api.api.reseller.searchFirst({r_code : app.context.api.currentReseller}, function(err, reseller){
                        if(err){
                            console.log("can't get reseller", err) ;
                        }else{
                            if(reseller){
                                if(VeloxWebView.i18n.getLang() !== reseller.r_lang){
                                    VeloxWebView.i18n.setLang(reseller.r_lang) ;
                                }
                                app.context.api.licenseErr = moment(reseller.r_date_end).isBefore(moment()) ;
                                if(!app.context.api.licenseErr && moment(reseller.r_date_end).isBefore(moment().add(1, "month"))){
                                    app.context.api.licenseWarn = moment(reseller.r_date_end).startOf("day").toDate() ;
                                }
                            }
                        }
                        console.log("go next");
                        return next() ; 
                    }) ;
                }else{
                    return next() ; 
                }
            }else{
                if(isActivationScreen(app)){
                    //on activate screen, OK
                    return next();
                }
                //not logged, open the login controller
                app.suspendNavigation("login", app.context.controllers.loginController, {}) ;
            }
        }
    },
    {
        type: "startup", //called on startup
        interceptor: function (app, callback){
            //refresh user session from server
            if(isActivationScreen(app)){
                //on activate screen, don't try to refresh user
                return callback();
            }

            app.context.api.refreshUser(function(err, user){
                if(err){ 
                    //not logged will be handled by ajax interceptor
                }
                if(user && user.login !== "anonymous" && user.realms && user.realms.length > 0){
                    require("../util/resellerInit")(app.context.api, callback) ;
                }else{
                    callback() ;
                }
            }) ;
        }
    }
];